import axios from 'axios';
import {
  LOGUOT_FAILURE,
  LOGUOT_REQUEST,
  LOGUOT_SUCCESS,
} from '../constants/ActionTypes';
import { BASE_URL } from '../constants/variables';
import ls from 'local-storage';

const logOutRequest = (isLoading) => {
  return {
    type: LOGUOT_REQUEST,
    payload: {
      isLoading,
    },
  };
};

const logOutSuccess = (vacancies) => {
  return {
    type: LOGUOT_SUCCESS,
    payload: {
      vacancies,
    },
  };
};

const Failure = (error) => {
  return {
    type: LOGUOT_FAILURE,
    payload: {
      error,
    },
  };
};

export const LogoutUser = (history) => {
  return async (dispatch) => {
    dispatch(logOutRequest(true));
    await axios
      .post(`${BASE_URL}/api/auth/token/logout/`, {})
      .then((res) => {
        if (res.status !== 204) {
          throw Error(res.statusText);
        }
        return res;
      })
      .then((res) => {
        dispatch(logOutSuccess(200));
        dispatch(logOutRequest(false));
        localStorage.removeItem('token');
        if (ls.get('sso_login')) {
          const ref_id = ls.get('refCompanyData').ref_id;
          const return_url =
            window.location.protocol +
            '//' +
            window.location.host +
            '/login?ref=' +
            ref_id;
          window.location.href =
            BASE_URL +
            '/oauth_logout?return_url=' +
            return_url +
            '&ref_id=' +
            ref_id;
        } else {
          window.location.href = '/login';
        }
      })
      .catch((err) => {
        dispatch(Failure(err));
        dispatch(logOutRequest(false));
      });
  };
};
